import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setViewerOrientation } from "../../CreateTPlan_2SegMRI/actions";
import { getMRIViewOrientation } from "../../CreateTPlan_4CancerLesion/helpers";
import { EMPTY_STRING, sceneOrientations } from "../../../constants";
import MRIModel from "../Viewers/Structures/MRI/MRIModel";
import NavCubeButton from "./NavCubeButton";
import RepeatIcon from "../../../ui/icons/RepeatIcon";
import AxialViewIcon from "../../../ui/icons/AxialViewIcon";
import SagittalViewIcon from "../../../ui/icons/SagittalViewIcon";
import CoronalViewIcon from "../../../ui/icons/CoronalViewIcon";
import "./styles.css";

class NavCubeModal extends Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        this.props.setViewerOrientation(sceneOrientations.AXIAL);

        if (this.props.mriModel && this.props.viewerOrientation) {
            this.props.mriModel.orientation = this.props.viewerOrientation;
        }
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.mriModel &&
            prevProps.viewerOrientation !== this.props.viewerOrientation
        ) {
            this.props.mriModel.orientation = this.props.viewerOrientation;
        }
    }

    handleClick(sceneOrientation) {
        if (this.props.mriModel) {
            this.props.mriModel.orientation = sceneOrientation;
        }
        this.props.setViewerOrientation(sceneOrientation);
        this.props.resetTick();
    }

    getImg(sceneOrientation) {
        switch (sceneOrientation) {
            case sceneOrientations.AXIAL:
                return AxialViewIcon;
            case sceneOrientations.SAGITTAL:
                return SagittalViewIcon;
            case sceneOrientations.CORONAL:
                return CoronalViewIcon;
            default:
                return EMPTY_STRING;
        }
    }

    getNavCubeButton(sceneOrientation, label, icon) {
        const ViewIcon = this.getImg(sceneOrientation);

        return (
            <NavCubeButton
                isCurrentOrientation={
                    this.props.viewerOrientation === sceneOrientation
                }
                orientation={sceneOrientation}
                handleClick={() => this.handleClick(sceneOrientation)}
                label={label}
                icon={icon || (ViewIcon ? <ViewIcon /> : null)}
            />
        );
    }

    getSurgeryNavCubeButton() {
        const { ViewIcon, label, showRepeatIcon } = getMRIViewOrientation(
            sceneOrientations.SURGERY_CORONAL
        );

        return this.getNavCubeButton(
            sceneOrientations.SURGERY_CORONAL,
            label,
            <div className="flex items-center gap-1">
                {showRepeatIcon && <RepeatIcon />}
                <ViewIcon />
            </div>
        );
    }

    render() {
        let display = this.props.active ? "active" : "inactive";

        return (
            <div
                className={`nav-cube-modal ${display}`}
                style={this.props.style}
            >
                {this.getNavCubeButton(sceneOrientations.AXIAL)}
                {this.getNavCubeButton(sceneOrientations.CORONAL)}
                {this.getNavCubeButton(sceneOrientations.SAGITTAL)}
                {this.props.surgeryModeActive && this.getSurgeryNavCubeButton()}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        viewerOrientation: state.CreatePlanSegReducer.viewerOrientation,
        surgeryModeActive: state.SurgeryModeReducer.autoLogoutPaused,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setViewerOrientation: (orientation) =>
            dispatch(setViewerOrientation(orientation)),
    };
};

NavCubeModal.propTypes = {
    mriModel: PropTypes.instanceOf(MRIModel),
    active: PropTypes.bool,
    dark: PropTypes.bool,
    style: PropTypes.object,
    resetTick: PropTypes.func,
    viewerOrientation: PropTypes.string,
    setViewerOrientation: PropTypes.func,
    surgeryModeActive: PropTypes.bool,
};

NavCubeModal.defaultProps = {
    active: false,
    dark: true,
};

export default connect(mapStateToProps, mapDispatchToProps)(NavCubeModal);
